<template>
    <v-container class="thunderer" grid-list-xl>
        <v-layout align-center justify-center fill-height row wrap>

            <v-flex 
            v-for="(val, i) in journal" 
            :key="i" 
            xs12 sm4 md3>
                <v-card class="mx-auto card-bounce">

                    <v-toolbar flat>
                        <v-toolbar-title>
                        <!--Выпуск-->{{ val.issue === 'old_covers' ? 'Старые выпуски' : '№ '+val.issue}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn v-if="val.pdf === 1"
                            fab small outlined
                            color="#ff7100"
                            :href="`/thunderer_src/pdf/N_${val.issue}.pdf`"
                            target='_blank'>
                            <!-- <v-icon>mdi-file-pdf-outline</v-icon> -->
                            <!-- fab small outlined / icon x-large -->
                            PDF
                        </v-btn>
                    </v-toolbar>

                    <v-img @click="dialog = true, dialogData = val"
                    contain
                    :style="{ cursor: 'pointer' }"
                    :class="[{ cover_old: val.issue === 'old_covers' }, 'card-style']"
                    :lazy-src="require('@/assets/animate-logo-white.svg')"
                    :src="`/thunderer_src/${val.issue}/${val.cover}.jpg`"/>
                </v-card>
            </v-flex>
            
        </v-layout>

        <!-- Модальное окно -->
        <v-dialog v-model="dialog">
            <v-card>
                <v-btn fab small outlined class="ma-1"
                @click="dialog = false" 
                :style="{ float: 'right' }">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-carousel :cycle=false class="px-5">
                    <v-carousel-item 
                    v-for="(item,j) in dialogData.page" 
                    :key="j" 
                    :src="`/thunderer_src/${dialogData.issue}/${item}.jpg`" 
                    contain>
                    </v-carousel-item>
                </v-carousel>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
export default {
    data: () => ({
        dialog: false, // переключатель окна диалога
        dialogData: Object, // данные для отображения в окне диалога
        journal: Array
    }),
    created() {
        fetch( "/thunderer_src.json" )
            .then( response => response.json())
            .then(json => this.journal = json);
    }
}
</script>

<style scoped>
    .cover_old {
        filter: blur(1px) sepia(100%);
    }
</style>